import { useEffect, useState } from 'react';
import { FILTERS_EVENT, FILTERS_STORAGE_KEY } from '../constants/filters';

const readFromStorage = () => {
  try {
    const raw = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const useAppliedFilters = () => {
  const [filters, setFilters] = useState(readFromStorage);

  useEffect(() => {
    const handler = (e) => {
      const next = Array.isArray(e.detail) ? e.detail : [];
      setFilters(next);
    };
    window.addEventListener(FILTERS_EVENT, handler);
    return () => window.removeEventListener(FILTERS_EVENT, handler);
  }, []);

  return filters;
};

export default useAppliedFilters;
